export default __webpack_public_path__ + "static/media/alarm.4012749f.svg";